import { component } from "picoapp";

export default component(async (node, ctx) => {
  const [{ default: KeenSlider }, { useUnveil, useAriaHidden }] =
    await Promise.all([
      import("keen-slider"),
      import("../lib/keen-slider"),
      import("keen-slider/keen-slider.min.css"),
    ]);

  const sliderContainer = node.querySelector("[data-slider]");
  const sliderElement = sliderContainer.querySelector("[data-keen-slider]");
  const sliderPrevElement = sliderContainer.querySelector("[data-prev]");
  const sliderNextElement = sliderContainer.querySelector("[data-next]");
  const productHandle = node.dataset.carouselProductHandle;

  const slider = KeenSlider(
    sliderElement,
    {
      defaultAnimation: {
        duration: 800,
      },
      loop: true,
      created: (instance) => {
        initNavigation(instance);
      },

      animationStarted: (instance) => {
        handleSlideMtrEvent();
      },

      useUnveil: {
        dataLazyImageSrc: "data-lazy-src",
        dataLazyImageSrcset: "data-lazy-srcset",
        dataLazyPoster: "data-lazy-poster",
        videoAutoPlay: true,
      },
    },
    [useUnveil, useAriaHidden]
  );

  function selectVariant(event, productHandle, slider) {
    if (
      (productHandle !== event.detail.product &&
        productHandle !== event.detail.bundleHandle) ||
      event.detail.variant.includes("|")
    )
      return;
    updateSlider(slider, event.detail.variantName);
  }

  function updateSlider(slider, slideId) {
    const slideIdx = slider.slides.findIndex(
      (slide) => slide.dataset.slideId === slideId
    );
    slider.moveToIdx(slideIdx);
  }

  function initNavigation(slider) {
    sliderPrevElement.addEventListener("click", () => {
      slider.prev();
    });

    sliderNextElement.addEventListener("click", () => {
      slider.next();
    });
  }

  function handleSlideMtrEvent() {
    const slideIndex = slider.track.absToRel(slider.track.details.abs);
    const slide = slider.slides[slideIndex];
    const rawData = slide.getAttribute("data-mtr-data") ?? "{}";

    try {
      const data = JSON.parse(rawData);
      window.maestro.fireTrackEvent(slide.dataset.mtrAs, data);
    } catch (e) {
      console.error("Could not parse [data-mtr-data] value");
    }
  }

  window.addEventListener("variant-selected:id", (event) =>
    selectVariant(event, productHandle, slider)
  );
});
